// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimValueDetails from '@deere/cps-it.warranty-model-factory/lib/claim-value-details';
import ClaimValueSummary from './claim-value-summary';
import ClaimValueTotals from './claim-value-totals';

const ClaimValueBody = props =>
    <section className='claim-value-body'>
        <ClaimValueSummary values={props.values}/>
        <ClaimValueTotals
            allowedActions={props.allowedActions}
            claimNumber={props.claimNumber}
            claimStatus={props.claimStatus}
            showAmountsInLocalCurrency={props.showAmountsInLocalCurrency}
            values={props.values}
        />
    </section>;

ClaimValueBody.displayName = 'ClaimValueBody';
ClaimValueBody.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    showAmountsInLocalCurrency: PropTypes.bool.isRequired,
    values: PropTypes.instanceOf(ClaimValueDetails).isRequired
};

export default ClaimValueBody;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value/claim-value-body.js